var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"action-bar-change-owner\" style=\"overflow: auto; width: auto; height: auto;\" class=\"popup popup-delete\"><div ng-style=\"{'background': theme_color}\" class=\"head\"><h2>Change Application{{bundles.length === 1 ? '' : 's'}} Owner</h2><a title=\"Close\" href=\"#\" ng-click=\"$dismiss()\" class=\"fancybox-item fancybox-close\"></a></div><div class=\"container\"><p>Change {{bundles.length === 1 ? 'this application' : 'these applications'}} owner to</p><input type=\"text\" placeholder=\"Enter username\" ng-model=\"new_owner\"><div ng-if=\"error_message\" class=\"error-container\"><p class=\"error-message\">{{error_message}}</p></div><div class=\"buttons\"><a ng-click=\"$dismiss()\" class=\"cancel cancel-button\">Cancel</a><a ng-click=\"change_owner()\" class=\"change-button\">Change</a><div class=\"cf\"></div></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/applicationChangeOwnerModal/applicationChangeOwnerModal.jade
// module id = 533
// module chunks = 0